import { Button, Modal } from "@mantine/core";
import { useEffect, useState } from "react";
import { TemplateModalState } from "../../../../../components/BuildingBlocks/TemplateDecisionCards/TemplateDecisionCards";
import { ModalFooter } from "../../../../../mantine/components/ModalFooter/ModalFooter";
import type {
  Paragraph6ContractPayload,
  Paragraph6ContractResponse
} from "../../../Paragraph6.types";
import { Paragraph6ContractModalContent } from "./Paragraph6ContractModalContent";

interface Paragraph6ContractModalProps {
  variantId: number;
  contractId?: string;
  isOpen?: boolean;
  onClose: () => void;
  templates?: Array<Paragraph6ContractResponse>;
}

function Paragraph6ContractModal({
  variantId,
  contractId,
  isOpen,
  onClose,
  templates
}: Paragraph6ContractModalProps) {
  const [modalState, setModalState] = useState<TemplateModalState>(
    TemplateModalState.None
  );

  const [selectedTemplate, setSelectedTemplate] =
    useState<Partial<Paragraph6ContractPayload> | null>(null);
  const [contractName, setContractName] = useState<string>("");
  const editMode = !!contractId;

  useEffect(() => {
    const singleTemplate = templates?.length === 1 && {
      ...templates[0],
      is_template: false,
      name: "",
      id: undefined,
      gemeinde_anteile_erzeuger: []
    };
    if (singleTemplate) setSelectedTemplate(singleTemplate);
    else setSelectedTemplate(null);
  }, [templates]);

  function handleClose() {
    setModalState(TemplateModalState.None);
    setSelectedTemplate(null);
    setContractName("");
    onClose();
  }

  const showContractForm =
    modalState === TemplateModalState.NewContract ||
    editMode ||
    !!selectedTemplate ||
    !templates ||
    templates.length === 0;

  const modalTitle = editMode
    ? contractName
      ? `Vertrag "${contractName}" bearbeiten`
      : "Vertrag bearbeiten"
    : "Vertrag hinzufügen";

  return (
    <Modal
      className="Paragraph6ContractModal"
      opened={isOpen || false}
      size="min(80vw, 1200px)"
      title={modalTitle}
      onClose={handleClose}
    >
      <Paragraph6ContractModalContent
        contractId={contractId}
        editMode={editMode}
        modalState={modalState}
        selectedTemplate={selectedTemplate}
        setModalState={setModalState}
        setSelectedTemplate={setSelectedTemplate}
        templates={templates}
        variantId={variantId}
        onClose={onClose}
        onContractNameChange={setContractName}
      />
      {!showContractForm && (
        <ModalFooter>
          <Button variant="default" onClick={onClose}>
            Abbrechen
          </Button>
          <Button color="primary" disabled type="submit">
            Speichern
          </Button>
        </ModalFooter>
      )}
    </Modal>
  );
}

export { Paragraph6ContractModal, Paragraph6ContractModalProps };
